window.Products.Accessory.VeganLeatherMakeupBag = function() {};
window.Products.Accessory.VeganLeatherMakeupBag.inherits(window.Products.Accessory.Accessory);